import React from 'react';
import { useLifeStore } from './hooks/useLifeStore';
import { useTheme, type ThemePreference } from './hooks/useTheme';
import { Onboarding } from './components/Onboarding';
import { LifeCalendar } from './components/LifeCalendar';
import type { LifetimeStyle } from './components/views/LifetimeView';
import type { ViewMode } from './types/life';
interface AppProps {
  /** Вьюха, с которой открывается календарь */
  initialView?: 'now' | 'life';
  /** Как «Вся жизнь» кодирует прожитое: faded — прожитое серым, struck — прожитое чёрным и зачёркнутым */
  lifetimeStyle?: 'faded' | 'struck';
  /** Тема: system следует настройкам ОС */
  theme?: 'system' | 'light' | 'dark';
}
export function App({
  initialView = 'now',
  lifetimeStyle = 'faded',
  theme = 'system'
}: AppProps) {
  const {
    profile,
    milestones,
    saveProfile,
    upsertMilestone,
    removeMilestone
  } = useLifeStore();
  const themeState = useTheme(theme as ThemePreference);
  return <div data-theme={themeState.resolved} className="bg-paper text-ink h-[100dvh] min-h-full w-full font-sans" data-id="element-0" data-mp="23ut9zyugts8o">
      {profile ? <LifeCalendar profile={profile} milestones={milestones} initialView={initialView as ViewMode} lifetimeStyle={lifetimeStyle as LifetimeStyle} theme={themeState} onSaveProfile={saveProfile} onUpsertMilestone={upsertMilestone} onRemoveMilestone={removeMilestone} data-id="element-1" data-mp="3mlat8v8bdto6" /> : <Onboarding onSubmit={saveProfile} data-id="element-2" data-mp="2zn678kkz7rhf" />}
    </div>;
}